// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Yf6f","fullView":"styles_fullView__3pWyx"};